/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="90.04"
        height="95.58"
        viewBox="0 0 90.04 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M43.38 40.97a10.92 10.92 0 1 0 10.91 10.91 10.91 10.91 0 0 0-10.91-10.91Zm0 2.5a8.42 8.42 0 1 1-8.42 8.41 8.41 8.41 0 0 1 8.42-8.38ZM53.04 68.4a1.252 1.252 0 0 1 .13 2.5H33.9a7.9 7.9 0 0 0-7.9 7.66v1.61a1.25 1.25 0 0 1-2.49.13v-1.49a10.41 10.41 0 0 1 10.13-10.4h19.4ZM70.16 55.13a10.92 10.92 0 1 0 10.91 10.92 10.92 10.92 0 0 0-10.91-10.92Zm0 2.5a8.42 8.42 0 1 1-8.42 8.42 8.42 8.42 0 0 1 8.42-8.42ZM79.64 82.57a10.4 10.4 0 0 1 10.4 10.12v1.64a1.25 1.25 0 0 1-2.49.13v-1.49a7.9 7.9 0 0 0-7.66-7.9H60.68a7.9 7.9 0 0 0-7.9 7.66v1.6a1.25 1.25 0 0 1-2.49.13v-1.49a10.41 10.41 0 0 1 10.13-10.4h19.24ZM36.27 0h-29A7.28 7.28 0 0 0-.01 7.28v18.74a7.33 7.33 0 0 0 7.28 7h12.88l9.44 8 .09.07a1.25 1.25 0 0 0 2-1v-7.03h4.63a7.28 7.28 0 0 0 7.19-7.28V7.28A7.28 7.28 0 0 0 36.27 0Zm-29 2.5h29a4.78 4.78 0 0 1 4.77 4.78v18.5a4.77 4.77 0 0 1-4.77 4.78h-6a1.25 1.25 0 0 0-1.13 1.24v5.61l-7.73-6.56a1.2 1.2 0 0 0-.81-.3H7.28a4.82 4.82 0 0 1-4.78-4.77V7.28A4.78 4.78 0 0 1 7.28 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M12.19 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49M21.77 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49M31.35 19.19a2.49 2.49 0 1 1 2.49-2.49 2.5 2.5 0 0 1-2.49 2.49"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleOneWordBubbleIcon';

export default Icon;
